import {useState, } from 'react';
import {Link} from 'react-router';
import {Button, Row, Divider} from 'antd';
import {BuyerSelectWidget} from "./BuyerSelectWidget";

import {createInvoice} from "../../api/Api";


import {handleNoSession} from "../../util/errorUtils";

export const NewInvoice = ({refresh, onRefresh, onApiFail, props}) => {
    const [selectedBuyer, setSelectedBuyer] = useState(null);
    const [value, setValue] = useState("");

     const [invoice, setInvoice] = useState(undefined);

    const onComplete = async () => {
        console.log('invoice complete');
        const buyerId = selectedBuyer.id

        // clear the page state immediately to avoid double completions
        setSelectedBuyer(null);
        setValue("");

        createInvoice(buyerId).then(r => {
            // successfully created invoice
            console.log(`successfully created invoice`);

            setInvoice(r);
            // notify the rest of the ui
            if (onRefresh) {
                onRefresh();
            }
        }).catch (e => {
            handleNoSession(e, onApiFail);
        })
    }

    const onBuyerSelect = (val) => {
        setSelectedBuyer(val);
    }

    const onReset = () => {
        setSelectedBuyer(undefined);
        setValue("");
        setInvoice(undefined);
    }

    const rowStyle= {
        margin: '5px'
    }

    const formView = <div style={{textAlign: 'left'}}>
        <div style={rowStyle}>
            <BuyerSelectWidget selectedBuyer={selectedBuyer} onSelect={onBuyerSelect} value={value} setValue={setValue} onApiFail={onApiFail} />
        </div>
        <Row style={rowStyle}>
            <Button onClick={onComplete}>Ok</Button>
        </Row>
    </div>

    return (invoice === undefined) ? formView : <div style={{textAlign: 'left'}}>
        <Link to={`/invoice/${invoice.id}`}>{`${invoice.invoiceNumber} Created`}</Link>
        <Divider />
        <Button onClick={onReset}>Create Another</Button>
    </div>;
}